module.exports = __webpack_public_path__ + "img/poste-bg.8b8413d8.jpg";